import type { Moment } from 'moment';

/**
 * Serialize a picked calendar day for a GraphQL `Date` input: the day the
 * user picked, as `YYYY-MM-DD`. Never `toISOString()`, which sends local
 * midnight as a UTC instant, a day early for anyone east of UTC (ENG-5747).
 * Returns null for an invalid (e.g. half-typed) date.
 *
 * The read half of the same contract is `parseFlexible` in
 * `components/EngagementHub/format.ts`.
 */
export function toDateOnly(value: Moment): string | null {
  return value.isValid() ? value.format('YYYY-MM-DD') : null;
}
